import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const CardsContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  
  @media (max-width: 1200px) {
    gap: 16px;
  }
  
  @media (max-width: 900px) {
    flex-wrap: wrap;
    gap: 12px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 12px;
  background-color: ${colors.white};
  border: 1px solid ${colors.gray300};
  flex: 1;
  min-width: 0;
  
  @media (max-width: 1024px) {
    padding: 12px 16px;
    gap: 12px;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 16px 20px;
    gap: 16px;
  }
`

export const CardIcon = styled.div<{ bgColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background-color: ${({ bgColor }) => bgColor};
  flex-shrink: 0;
  
  @media (max-width: 1024px) {
    width: 36px;
    height: 36px;
  }
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  min-width: 0;
`

export const CardTitle = styled.div`
  font-size: 0.875rem;
  line-height: 1.4;
  color: ${colors.gray600};
  margin-bottom: 4px;
  
  @media (max-width: 1024px) {
    font-size: 0.75rem;
  }
`

export const CardAmount = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  color: ${colors.gray900};
  
  @media (max-width: 1024px) {
    font-size: 1.25rem;
  }
  
  @media (max-width: 768px) {
    font-size: 1.125rem;
  }
`


